import { API, authClient } from "../index";

export const postOperarioCategory = async (category, accessToken) => {
	return authClient(accessToken).post(`${API}/operario-categories`, category);
};

export const getOperarioCategories = (accessToken) => {
	return authClient(accessToken).get(`${API}/operario-categories`);
};

export const getOperarioCategoryById = (id, accessToken) => {
	return authClient(accessToken).get(`${API}/operario-categories/${id}`);
};

export const updateOperarioCategory = async (id, category, accessToken) => {
	return authClient(accessToken).put(
		`${API}/operario-categories/${id}`,
		category
	);
};

export const deleteOperarioCategory = (id, accessToken) => {
	return authClient(accessToken).delete(`${API}/operario-categories/${id}`);
};
